import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { translateProviders } from './core/shared/providers/translate.provider';
import { dateLocaleProvider } from './core/shared/providers/dateLocale.provider';
import { authInterceptor } from './core/shared/interceptor/auth.interceptor';
import { refreshTokenInterceptor } from './core/shared/interceptor/refresh.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withInterceptors([authInterceptor, refreshTokenInterceptor])),
    translateProviders,
    dateLocaleProvider,
  ],
};
